import { IViewsState } from '../../lib/interface'
import { IViewAction } from './actions'

import * as types from './types'

const savedSelections =
localStorage.getItem('viewsSelections')

const data = savedSelections ? JSON.parse(savedSelections) : false

const defaultState: IViewsState = {
  new: {
    selections: savedSelections ? {
      ...data
    } : {
      factoids: [],
      classes: [],
      businessLines: []
    }
  }
}

const reducer = (state: IViewsState = defaultState, action: IViewAction) => {
  const id = action.payload ? action.payload.id : ''
  switch (action.type) {
    case types.USER_SELECT_CLASS:
      return {
        ...state,
        new: {
          selections: {
            ...state.new.selections,
            classes: [...state.new.selections.classes, id]
          }
        }
      }
    case types.USER_DESELECT_CLASS:
      return {
        ...state,
        new: {
          selections: {
            ...state.new.selections,
            classes: state.new.selections.classes.filter((selectedId: number) => selectedId !== id)
          }
        }
      }
    case types.FACTOID_SELECTIONS_SORT_SUCCESS:
      return {
        ...state,
        new: {
          ...state.new,
          selections: {
            ...state.new.selections,
            factoids: action.payload
          }
        }
      }
    case types.USER_SELECT_FACTOID:
      return {
        ...state,
        new: {
          ...state.new,
          selections: {
            ...state.new.selections,
            factoids: [...state.new.selections.factoids, id]
          }
        }
      }
    case types.USER_DESELECT_FACTOID:
      return {
        ...state,
        new: {
          ...state.new,
          selections: {
            ...state.new.selections,
            factoids: state.new.selections.factoids.filter(
              (factoidId: number) => factoidId !== id
            )
          }
        }
      }
    case types.GENERATE_BUSINESS_LINE_SELECTIONS:
      return {
        ...state,
        new: {
          ...state.new,
          selections: {
            ...state.new.selections,
            businessLines: action.payload
          }
        }
      }
    case types.USER_ADD_BUSINESS_LINE:
      return {
        ...state,
        new: {
          ...state.new,
          selections: {
            ...state.new.selections,
            // @ts-ignore
            businessLines: [...state.new.selections.businessLines].includes(id) ? [...state.new.selections.businessLines] : [...state.new.selections.businessLines, id]
          }
        }
      }
    case types.USER_REMOVE_BUSINESS_LINE:
      return {
        ...state,
        new: {
          ...state.new,
          selections: {
            ...state.new.selections,
            businessLines: state.new.selections.businessLines.filter(
              (businessLineId: number) => businessLineId !== id
            )
          }
        }
      }

    case types.RESET_SELECTIONS:
      return {
        ...state,
        new: {
          selections: {
            factoids: [],
            classes: [],
            businessLines: []
          }
        }
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/duck/reducers.ts